import { Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import "./MileStone.css";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface AddMileStoneProps {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

const AddMileStone = ({ show, handleClose, data }: AddMileStoneProps) => {
  const [isLoading, setLoading] = useState(false);
  const [year, setYear] = useState(""); // ✅ added year state
  const [value, setValue] = useState("");
  const [highlights, setHighlights] = useState<{ title: string }[]>([
    { title: "" },
  ]);

  useEffect(() => {
    if (data) {
      setYear(data.year || "");
      if (data.description == 0) {
        setHighlights([{ title: "" }]);
      } else {
        setHighlights(
          data.description.map((h: any) => ({
            title: h.title,
          }))
        );
      }
    } else {
      // Reset form when adding new
      setYear("");
      setHighlights([{ title: "" }]);
    }
  }, [data, show]);

  const onSubmit = async () => {

    if (!year.trim()) {
      toast.error("Year is required");
      return;
    }

    // ✅ Check at least 1 description
    const validHighlights = highlights.filter(
      (h) => h.title && h.title.trim() !== ""
    );

    if (validHighlights.length === 0) {
      toast.error("At least 1 description is required");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    // ✅ Add ID only when updating
    if (data?._id) {
      formData.append("_id", data._id);
    }
    formData.append("year", year);
    if (
      highlights.length > 0 &&
      highlights.some((h) => h.title.trim() !== "")
    ) {
      formData.append("description", JSON.stringify(highlights));
    }

    WebService.fileUploadAPI({
      action: `milestone-awards/addUpdateMileStone`,
      body: formData,
    })
      .then((res: any) => {
        toast.success(res.message);
        setLoading(false);
        handleClose();
      })
      .catch((err: any) => {
        setLoading(false);
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          handleClose();
        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Milestones and Achievements</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Form.Group className="mb-3" controlId="year">
              <Form.Label className="label">Year<span className="text-danger"> *</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter year (e.g., 2013-2015)"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="highlights">
              <Form.Label className="label">Descripiton<span className="text-danger"> *</span></Form.Label>
              {highlights.map((highlight, index) => (
                <div
                  key={index}
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData("highlightIndex", index.toString());
                  }}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    const fromIndex = Number(
                      e.dataTransfer.getData("highlightIndex")
                    );
                    if (fromIndex === index) return;
                    const newHighlights = [...highlights];
                    const [moved] = newHighlights.splice(fromIndex, 1);
                    newHighlights.splice(index, 0, moved);
                    setHighlights(newHighlights);
                  }}
                  style={{ cursor: "move" }}
                >
                  <div className="d-flex align-items-start">
                    <span
                      style={{
                        cursor: "grab",
                        marginRight: 8,
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20,
                        color: "#888",
                        marginTop: 10,
                      }}
                      title="Drag to reorder"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <circle cx="5" cy="6" r="1.5" />
                        <circle cx="5" cy="10" r="1.5" />
                        <circle cx="5" cy="14" r="1.5" />
                        <circle cx="11" cy="6" r="1.5" />
                        <circle cx="11" cy="10" r="1.5" />
                        <circle cx="11" cy="14" r="1.5" />
                      </svg>
                    </span>
                    <div style={{ flex: 1 }} className="highlight-item">
                      <div className="d-flex mt-2">
                        <Form.Control
                          type="text"
                          placeholder={`Title`}
                          value={highlight.title}
                          onChange={(e) => {
                            const newHighlights = [...highlights];
                            newHighlights[index].title = e.target.value;
                            setHighlights(newHighlights);
                          }}
                        />
                        <div className="d-flex mt-2">
                          <PlusSquareFill
                            onClick={() => {
                              setHighlights([...highlights, { title: "" }]);
                            }}
                            className="ms-2 me-2 cursor-pointer"
                          />
                          {highlights.length > 1 && (
                            <DashSquareFill
                              onClick={() => {
                                const newHighlights = highlights.filter(
                                  (_, i) => i !== index
                                );
                                setHighlights(newHighlights);
                              }}
                              className="cursor-pointer"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Form.Group>
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={onSubmit}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddMileStone;
